// What the world stage shows on every tab: time of day from the trip clock and weather live during
// the trip (data/weather) or else from the pack climatology, each overridable from the World panel.
import { useMemo } from 'react'
import type { Pack } from '../../shared/pack/schema'
import { useLiveWeather } from '../data/weather'
import { climateFor, todFor, wxFor } from '../map/bindings'
import { useWorldOverride } from '../map/worldOverride'
import type { WorldState } from '../stage/types'
import type { TripNow } from './useTripNow'

export function useWorld(pack: Pack, now: TripNow): WorldState {
  const override = useWorldOverride()
  // During the trip, the real weather where we are (F8); otherwise the month's typical weather.
  const live = useLiveWeather(pack, now.clock, now.nowMs)
  return useMemo(
    () => ({
      tod: override.tod ?? todFor(now.clock.time, pack.meta.daylight),
      wx: override.wx ?? (live ? (live.heavy ? 2 : wxFor(live.condition)) : wxFor(climateFor(pack, now.clock)?.condition)),
    }),
    [override.tod, override.wx, now.clock, pack, live],
  )
}
